import axios from 'axios';

export default async function createBatchCompanies({
  accessToken,
  companyFile,
  userId,
  setIsCreatingCompanies,
  setTokenLikeExpired,
  feedbackMessage,
}) {
  const formData = new FormData();
  formData.append('file', companyFile);

  try {
    if (setIsCreatingCompanies) setIsCreatingCompanies(true);
    if (feedbackMessage) feedbackMessage('Criando empresas...', { variant: 'warning' });

    const { data } = await axios.post(
      `${process.env.REACT_APP_COMPANIES_API_URL}/batch/${userId}`,
      formData,
      {
        headers: {
          'Content-Type': 'multipart/form-data',
          Authorization: `Bearer ${accessToken}`,
        },
      },
    );

    if (feedbackMessage) feedbackMessage('Empresas criada com sucesso', { variant: 'success' });

    return data;
  } catch (err) {
    const { response } = err || {};
    const { data: { message } } = response || {};

    if (err.response?.status === 401 && setTokenLikeExpired) setTokenLikeExpired();
    if (feedbackMessage) feedbackMessage(message, { variant: 'error' });

    console.log(err.response);

    return err;
  } finally {
    if (setIsCreatingCompanies) setIsCreatingCompanies(false);
  }
}
